import type { ReactNode } from 'react'
import { useTranslations } from 'next-intl'
import { useFeatureFlags } from '@node-space/hooks'
import { Callout } from '@node-space/ui-components'
import { BVNK } from '@/utils/constants'
import { Link } from '../Link'

export const DisclaimerWrapper = ({ children }: { children: ReactNode }) => {
  const t = useTranslations()
  const { enableCopyTextDeelPayOut } = useFeatureFlags()
  const learnMoreUrl = process.env.NEXT_PUBLIC_LEARN_MORE_URL ?? ''
  const deelAddOnDisclaimerText = enableCopyTextDeelPayOut && t('disclaimerBVNKSeller')

  return (
    <Callout>
      <p>
        {children} {BVNK && <Link href={learnMoreUrl}>{t('learnMore')}</Link>}{' '}
        {deelAddOnDisclaimerText}
      </p>
    </Callout>
  )
}
